export const DEVICE_RESPONSE_SUCCESS = 'SUCCESS';
export const DEVICE_RESPONSE_ERROR = 'ERROR';

export default {
  DEVICE_RESPONSE_SUCCESS,
  DEVICE_RESPONSE_ERROR,
};
